'use client'

import { AppError } from '@/features/errors/ui'

export default AppError
